var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cards-paganation"},[_c('div',{staticClass:"page-text"},[_vm._v(_vm._s(_vm.currentPage)+"/"+_vm._s(_vm.totalPage))]),_c('ul',{staticClass:"dot-con"},_vm._l((_vm.totalPage),function(item,index){return _c('li',{key:index,class:['normal-dot', item <= _vm.currentPage ? 'active-dot' : 'normal-dot']})}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }